import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellNombre = ({ item }) => {
  return (
    <TableCellDesktop
      max={75}
      value={item.value}
    />
  )
}

export default TableCellNombre
